<template>
    <div class="codics-lottery-dzp-aaa-body">
        <MyDialog v-model="recordsDialog" :width="'700px'" :title="'抽奖记录'">
            <div class="codics-lottery-dzp-aaa-records-list-item" v-for="(item, index) in recordsData" :key="index">
                <div class="codics-lottery-dzp-aaa-records-list-item-txt">{{ item.lottery.name }}</div>
                <div class="codics-lottery-dzp-aaa-records-list-item-time">{{ initTime(item.ctime) }}</div>
            </div>
        </MyDialog>
        <MyDialog class="codics-lottery-dzp-cjjg" v-model="zjDialog" :width="'700px'" :title="'抽奖结果'">
            <div style="position: relative;float: left;height: 300px;width: 100%;">
                <el-image
                    style="height: 100px;width: 100px;position: absolute;margin: auto;top: -75px;left: 0;right: 0; bottom: 0;"
                    :src="zjImg" fit="cover"></el-image>
            </div>
            <div class="codics-lottery-dzp-aaa-zj-btn" @click="jumpLj">{{ activeData.def == zjId ? '关闭弹窗' : '跳转领奖' }}
            </div>
        </MyDialog>
        <MyDialog v-model="recordsDialog2" :width="'700px'" :title="'我的奖品'">
            <div class="codics-lottery-dzp-aaa-records-list-item" v-for="(item, index) in recordsData2" :key="index"
                @click="handleClick(item);">
                <div class="codics-lottery-dzp-aaa-records-list-item-txt">{{ item.lottery.name }}</div>
                <a class="codics-lottery-dzp-aaa-records-list-item-time">{{
            activeData.type == 0 ? (item.aid == 0 ?
                '填写地址' : '查看物流') : (item.state == 0 ? '待核销' : '已核销')
        }}</a>
            </div>
        </MyDialog>
        <el-image class="codics-lottery-dzp-aaa-img" :src="backImg" fit="fill"></el-image>
        <el-image class="codics-lottery-dzp-aaa-title" :src="titleTxt" fit="fill"></el-image>
        <div class="codics-lottery-dzp-aaa-tip" v-show="hourTxt < 0 && minuteTxt < 0 && secondTxt < 0">
            <div class="codics-lottery-dzp-aaa-tip-txt">您还有{{ lotteryCount }}次抽奖机会</div>
        </div>
        <LuckyWheel v-show="hourTxt < 0 && minuteTxt < 0 && secondTxt < 0" ref="myLucky"
            class="codics-lottery-dzp-aaa-luckywheel" width="300px" height="300px" :prizes="prizes" :blocks="blocks"
            :buttons="buttons" @start="startCallback" @end="endCallback" />
        <div class="codics-shop-lottery-button-box" style="margin-top: 40px;"
            v-show="hourTxt < 0 && minuteTxt < 0 && secondTxt < 0">
            <div class="codics-shop-lottery-button-card">
                <div class="codics-shop-lottery-button-viw"></div>
                <div class="codics-shop-lottery-button iconfont" @click="listRecordFuc();">&#xe866; 抽奖记录</div>
                <div class="codics-shop-lottery-button iconfont" style="margin-left: 10px;" @click="listRecordFuc2();">
                    &#xe7b2; 我的奖品</div>
                <!-- <div class="codics-shop-lottery-wdjp" @click="listRecordFuc();">抽奖记录</div> -->
            </div>
        </div>
        <div class="codics-lottery-dzp-aaa-time" v-show="hourTxt >= 0 && minuteTxt >= 0 && secondTxt >= 0">
            <div class="codics-lottery-dzp-aaa-time-card">
                <div class="codics-lottery-dzp-aaa-time-card-title">倒计时</div>
                <div class="codics-lottery-dzp-aaa-time-card-title"
                    style="height: 25px;line-height: 25px;font-size: 17px;color: rgba(255, 255, 255, .5);margin-top: 0;">
                    COUNT DOWN</div>
                <div class="codics-lottery-dzp-aaa-time-card-title iconfont"
                    style="height: 35px;line-height: 35px;font-size: 22px;margin-top: 0;">
                    &#xe61f;</div>
                <div class="codics-lottery-dzp-aaa-time-card-title"
                    style="height: 35px;line-height: 35px;font-size: 16px;margin-top: 0;">
                    距离活动开始还有</div>
                <div class="codics-lottery-dzp-aaa-time-card-box">
                    <div class="codics-lottery-dzp-aaa-time-card-box-item">{{ towTime(hourTxt) }}</div>
                    <div class="codics-lottery-dzp-aaa-time-card-box-item">{{ towTime(minuteTxt) }}</div>
                    <div class="codics-lottery-dzp-aaa-time-card-box-item" style="margin-right: 0px;">{{
            towTime(secondTxt) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="codics-shop-lottery-users-title">中奖用户名单</div>
        <div class="codics-shop-lottery-users-box">
            <div class="codics-shop-lottery-users-card">
                <ul>
                    <li v-for="(item, index) in winRecordsData" :key="index">{{ '用户 **' + (item.nick == null ?
            item.oid.slice(-2) : item.nick.slice(-2))
                        }}<div>
                            {{ item.lottery.name }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="codics-shop-lottery-users-title">抽奖活动规则</div>
        <div class="codics-shop-lottery-users-box" style="height: fit-content !important;">
            <div class="codics-shop-lottery-users-card codics-shop-lottery-users-card2"
                style="line-height: 2;white-space: break-spaces;" v-html="lotteryInfo.remark">
            </div>
        </div>
        <el-drawer title="填写地址" :visible.sync="areaDialog" direction="btt" size="calc(100% - 60px)">
            <el-input style="width: calc(100% - 30px);left: 50%;transform: translateX(-50%);margin-bottom: 15px;"
                v-model="thData.name" placeholder="请输入收件人姓名"></el-input>
            <el-input style="width: calc(100% - 30px);left: 50%;transform: translateX(-50%);margin-bottom: 15px;"
                v-model="thData.phone" type="number" placeholder="请输入收件手机号"></el-input>
            <el-cascader style="width: calc(100% - 30px);left: 50%;transform: translateX(-50%);margin-bottom: 15px;"
                size="large" :options="areaOptions" v-model="addtions" @change="handleChange">
            </el-cascader>
            <el-input style="width: calc(100% - 30px);left: 50%;transform: translateX(-50%);margin-bottom: 15px;"
                type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入地址详情" v-model="thData.remark">
            </el-input>
            <div class="codics-shop-detail-wyth" @click="bindAreaFuc">确定提货</div>
        </el-drawer>
        <el-drawer title="提货进度" :visible.sync="jdDilog" direction="btt" size="calc(100% - 60px)">
            <el-timeline :reverse="false" style="width: calc(100% - 30px);margin-top: 10px;">
                <el-timeline-item v-for="(activity, index) in wiliuData" :key="index" :timestamp="activity.time"
                    placement="top">
                    <el-card>
                        <h4>{{ activity.context }}</h4>
                        <p>数据更新于 {{ activity.time }}</p>
                    </el-card>
                </el-timeline-item>
            </el-timeline>
        </el-drawer>
        <el-drawer class="codics-shop-lottery-jphx-dialog" title="奖品核销" :visible.sync="hexDialog" direction="btt"
            size="calc(100% - 60px)">
            <div class="codics-shop-lottery-jphx-body">
                <div class="codics-shop-lottery-jphx-card"
                    v-show="activeData.type == 1 && (activeData.ist == 0 || (istName != null && istPhone != null))">
                    <div class="codics-shop-lottery-jphx-card-radio" style="left: -20px;"></div>
                    <div class="codics-shop-lottery-jphx-card-radio" style="right: -20px;"></div>
                    <div class="codics-shop-lottery-jpxx-view">
                        <el-image class="codics-shop-lottery-jpxx-img" :src="zjImg" fit="cover"></el-image>
                        <div class="codics-shop-lottery-jpxx-name" v-html="nowJp2.name"></div>
                        <div class="codics-shop-lottery-jpxx-name" v-html="nowJp.state == 0 ? '待核销' : '已核销'"></div>
                        <div class="codics-shop-lottery-jpxx-count">x1</div>
                    </div>
                    <div class="codics-shop-lottery-jpxx-qrcode">
                        <el-image class="codics-shop-lottery-jpxx-qrcode-img" :src="nowQr" fit="cover"
                            :style="{ 'filter': nowJp.state == 0 ? '' : 'blur(4px)' }"></el-image>
                    </div>
                    <div class="codics-shop-lottery-jphx-card-tip">请到线下兑奖处扫码核销，领取奖品！</div>
                </div>
                <el-input v-show="activeData.type == 1 && activeData.ist == 1 && istName == null && istPhone == null"
                    style="width: 100%;left: 50%;transform: translateX(-50%);margin-bottom: 15px;" v-model="istName2"
                    placeholder="请输入您的姓名"></el-input>
                <el-input v-show="activeData.type == 1 && activeData.ist == 1 && istName == null && istPhone == null"
                    style="width: 100%;left: 50%;transform: translateX(-50%);margin-bottom: 15px;" v-model="istPhone2"
                    type="number" placeholder="请输入您的手机号"></el-input>
                <div class="codics-shop-detail-wyth"
                    v-show="activeData.type == 1 && activeData.ist == 1 && istName == null && istPhone == null"
                    style="left: 0;" @click="hexFuc">生成核销码</div>
                <div class="codics-shop-detail-wyth"
                    v-show="activeData.type == 1 && activeData.ist == 1 && istName != null && istPhone != null"
                    style="left: 0;" @click="istName = null; istPhone = null;">重新填写个人信息</div>
            </div>
        </el-drawer>
    </div>
</template>
<style>
.codics-lottery-dzp-aaa-time {
    height: 410px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-lottery-dzp-aaa-time-card {
    height: 240px;
    width: 180px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #e83632;
}

.codics-lottery-dzp-aaa-time-card-title {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    text-align: center;
    line-height: 30px;
    margin-top: 20px;
    font-size: 25px;
    color: #FFF;
}

.codics-lottery-dzp-aaa-time-card-box {
    height: 90px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 20px;
}

.codics-lottery-dzp-aaa-time-card-box-item {
    height: 50%;
    width: calc(33.33333% - 3px);
    position: relative;
    float: left;
    top: 25%;
    background: #333;
    margin-right: 4.5px;
    line-height: 45px;
    text-align: center;
    font-size: 23px;
    color: #FFF;
    font-weight: 700;
}

.codics-lottery-dzp-aaa-time-card-box-item::after {
    content: '';
    height: 2px;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #e83632;
}
</style>
<script>
var aCookie = document.cookie.split(";");
for (var i = 0; i < aCookie.length; i++) {
    var aCrumb = aCookie[i].split("=");
    if (aCrumb[0].toString().trim().includes('lottery-js') || aCrumb[0].toString().trim().includes('lottery-css')) {
        delCookie(aCrumb[0].toString().trim());
    }
}
import { regionData, codeToText, TextToCode } from "element-china-area-data";
import dayjs from 'dayjs';
import QRCode from 'qrcode';
import MyDialog from '@/components/MyDialog';
import { listLotterys, startLottery, listRecord, listRecord2, randRecords, bindArea, getDetail } from '@/api';
import { dateToTime, loadJs, loadCss, saveData, readData } from "@/utils/myutils";
import { delCookie, getCookie, setCookie } from "@/utils/mycookie";
export default {
    data() {
        return {
            backImg: 'https://cdn.bosscaigou.com/huayuan/img/yasuo_%E5%AD%A3%E5%BF%B5%E7%B4%A0%E6%9D%90-%2812%29.webp',
            titleTxt: 'https://cdn.bosscaigou.com/huayuan/img/yasuo_%E7%BB%84%209.webp',
            zjDialog: false,
            zjImg: '',
            zjId: -1,
            nowJp: {},
            nowJp2: {},
            recordsDialog2: false,
            recordsDialog: false,
            areaDialog: false,
            jdDilog: false,
            hexDialog: false,
            nowQr: '',
            lotteryCount: 0,
            lotteryList: [],
            lotteryInfo: {},
            addtions: {},//存储地址数据
            areaOptions: regionData,
            recordsData: [],
            recordsData2: [],
            winRecordsData: [],
            activeData: {},
            thData: {
                id: null,
                name: '',
                phone: '',
                province: '',
                city: '',
                area: '',
                remark: ''
            },
            wiliuData: [],
            blocks: [
                {
                    padding: '31px',
                    imgs: [{
                        src: '../img/bck.webp',
                        width: '100%',
                        height: '100%'
                    }]
                }
            ],
            buttons: [
                {
                    radius: '45%',
                    imgs: [{
                        src: '../img/zhizhen.webp',
                        width: '100%',
                        top: '-140%'
                    }],
                    fonts: [{ text: '开始\n抽奖', top: '-18px', fontSize: '15px', fontColor: '#444' }]
                }
            ],
            prizesData: {
                color: '#FFF',
                color2: '#7021E8',
                color3: '',
                color4: '',
                imgs: {

                },
                fonts: {

                }
            },
            prizes: [
                // { background: '#FFF', imgs: [{ src: 'https://cdn.bosscaigou.com/%E6%8A%BD%E5%A5%96/img/%E5%BF%83%E7%A2%8E-copy.svg', height: '30px', width: '30px', top: '7px' }], fonts: [{ text: '谢谢参与', fontColor: '#333', fontSize: '10px', top: '40px' }] },
                // { background: '#7021E8', imgs: [{ src: 'https://cdn.bosscaigou.com/%E6%8A%BD%E5%A5%96/img/%E7%BA%A2%E5%8C%85.svg', height: '30px', width: '30px', top: '7px' }], fonts: [{ text: '5元红包', fontColor: '#FFF', fontSize: '10px', top: '40px' }] },
                // { background: '#FFF', imgs: [{ src: 'https://cdn.bosscaigou.com/%E6%8A%BD%E5%A5%96/img/%E7%A4%BC%E7%9B%92.svg', height: '30px', width: '30px', top: '7px' }], fonts: [{ text: '牛肉礼盒', fontColor: '#333', fontSize: '10px', top: '40px' }] },
                // { background: '#7021E8', imgs: [{ src: 'https://cdn.bosscaigou.com/%E6%8A%BD%E5%A5%96/img/%E7%A9%BA%E8%B0%83.svg', height: '30px', width: '30px', top: '7px' }], fonts: [{ text: '空调一部', fontColor: '#FFF', fontSize: '10px', top: '40px' }] },
                // { background: '#FFF', imgs: [{ src: 'https://cdn.bosscaigou.com/%E6%8A%BD%E5%A5%96/img/%E6%89%8B%E6%9C%BA-%E4%B8%80%E5%8A%A09pro-%E7%BB%84%E5%90%88.svg', height: '30px', width: '30px', top: '7px' }], fonts: [{ text: '手机一部', fontColor: '#333', fontSize: '10px', top: '40px' }] },
                // { background: '#7021E8', imgs: [{ src: 'https://cdn.bosscaigou.com/%E6%8A%BD%E5%A5%96/img/svg%20%287%29.svg', height: '30px', width: '30px', top: '7px' }], fonts: [{ text: '苹果电脑', fontColor: '#FFF', fontSize: '10px', top: '40px' }] }
            ],

            hourTxt: -1,

            minuteTxt: -1,

            secondTxt: -1,

            istName: null,

            istPhone: null,

            istName2: null,

            istPhone2: null

        }
    },
    mounted() {

        this.listLotterysFuc();

        this.randRecordsFuc();

    },
    // 动态设置页面标题、关键字和描述等属性  
    metaInfo() {
        return {
            title: this.$route.meta.metaInfo.title,
            meta: [
                { name: "keywords", content: this.$route.meta.metaInfo.keywords },
                { name: "description", content: this.$route.meta.metaInfo.description },
            ]
        }
    },
    methods: {
        handleStr(str) {
            var arr = str.replace(/[`:_.~!@#$%^&*() \+ =<>?"{}|, \/ ;' \\ [ \] ·~！@#￥%……&*（）—— \+ ={}|《》？：“”【】、；‘’，。、]/g,
                '');
            return arr;
        },
        hexFuc() {
            if (this.istName2 != null && this.istPhone2 != null) {

                if (this.istName2.length > 10) {

                    this.$message({
                        showClose: true,
                        message: '名字长度不能超过10个字符！',
                        type: 'warning'
                    });

                    return;

                }

                if (this.istPhone2.length != 11) {

                    this.$message({
                        showClose: true,
                        message: '手机号码长度必须为11位纯数字！',
                        type: 'warning'
                    });

                    return;

                }

                this.istName = this.istName2;

                this.istPhone = this.istPhone2;

                this.createQrCode("https://hd.katihuo.com/sign/" + this.$route.params.id + "?code=" + this.$route.query.code + "&j=" + this.nowJp.id + "&n=" + this.istName + "&p=" + this.istPhone);

            } else {

                this.$message({
                    showClose: true,
                    message: '请完整填写个人信息！',
                    type: 'warning'
                });

            }
        },
        towTime(n) {
            return n >= 0 && n < 10 ? '0' + n : '' + n;
        },
        handleClick(item) {

            this.nowJp = item;

            this.nowJp2 = item.lottery;

            this.zjId = this.nowJp2.id;

            this.zjImg = 'https://cdn.bosscaigou.com/' + this.nowJp2.img;

            if (this.activeData.type == 0) {

                this.thData.id = item.id;

                this.areaDialog = item.aid == 0;

                item.aid != 0 && this.getDetailFuc();

            } else {

                this.createQrCode("https://hd.katihuo.com/sign/" + this.$route.params.id + "?code=" + this.$route.query.code + "&j=" + this.nowJp.id);

                this.hexDialog = true;

            }

            // this.zjId = data.data.id;

            // this.zjImg = 'https://cdn.bosscaigou.com/' + data.data.img;

        },
        async createQrCode(QRlink) {   // QRlink是二维码的内容
            let opts = {
                errorCorrectionLevel: "L",//容错级别
                type: "image/png",//生成的二维码类型
                quality: 0.3,//二维码质量
                margin: 1,//二维码留白边距
                width: 100,//宽
                height: 100,//高
                text: QRlink,//二维码内容
                color: {
                    dark: "#000",//前景色
                    light: "#fff"//背景色
                }
            };
            await QRCode.toDataURL(QRlink, opts, (err, url) => {
                if (err) throw err
                //将生成的二维码路径复制给data的QRImgUrl
                // console.log(url)
                this.nowQr = url;
            });
        },
        jumpLj() {

            this.zjDialog = false;

            if (this.zjId != this.activeData.def) {

                if (this.activeData.type == 0) {

                    this.thData.id = this.nowJp.id;

                    this.areaDialog = true;

                } else {

                    this.createQrCode("https://hd.katihuo.com/sign/" + this.$route.params.id + "?code=" + this.$route.query.code + "&j=" + this.nowJp.id);

                    this.hexDialog = true;

                }

            }

        },
        async getDetailFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await getDetail({ id: this.thData.id });

            loading.close();

            if (data.code == 200) {

                switch (data.data) {

                    case 0:

                        console.log("订单未核销！");

                        this.wiliuData = [
                            {
                                time: dateToTime(new Date(data.ctime)),
                                context: '订单正在等待核销！'
                            }
                        ]

                        break;

                    case 1:

                        console.log("订单等待出库！");

                        this.wiliuData = [
                            {
                                time: dateToTime(new Date()),
                                context: '订单等待出库！'
                            },
                            {
                                time: dateToTime(new Date(data.ctime)),
                                context: '订单已核销！'
                            }
                        ]

                        break;

                    case 3:

                        this.wiliuData = [
                            {
                                time: dateToTime(new Date(data.ctime)),
                                context: '订单已被冻结！'
                            }
                        ]

                        break;

                    case 4:

                        this.wiliuData = [
                            {
                                time: dateToTime(new Date(data.ctime)),
                                context: '订单已被关闭！'
                            }
                        ]

                        break;

                    default:

                        let t = JSON.parse(data.data.body).data;

                        this.wiliuData = [
                            {
                                time: t[t.length - 1].time,
                                context: '订单已出库！'
                            },
                            {
                                time: dateToTime(new Date(data.ctime)),
                                context: '订单已核销！'
                            }
                        ]

                        this.wiliuData = t.concat(this.wiliuData);

                        break;

                }

                this.jdDilog = true;

            } else {

                this.$message.error(data.message);

            }

        },
        async bindAreaFuc() {

            if (this.thData.name == '' || this.thData.phone == '' || this.thData.phone.length != 11) {
                this.$message({
                    showClose: true,
                    message: this.thData.name == '' ? '收件人姓名不能为空！' : (this.thData.phone == '' ? '收件手机号不能为空！' : '手机号码格式不正确！'),
                    type: 'warning'
                });
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await bindArea({ ...this.thData, code: this.$route.query.code });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '地址填写成功！',
                    type: 'success'
                });

                setTimeout(() => {
                    window.location.reload();
                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        handleChange(value) {

            value.forEach((item, index) => {

                switch (index) {

                    case 0:

                        this.thData.province = codeToText[item];

                        break;

                    case 1:

                        this.thData.city = codeToText[item];

                        break;

                    case 2:

                        this.thData.area = codeToText[item];

                        break;

                }

            });

        },
        async randRecordsFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await randRecords({ id: this.$route.params.id, count: 10 });

            loading.close();

            if (data.code == 200) {

                if (data.data.length != 0) {

                    this.winRecordsData = data.data;

                    let t = data.data.length;

                    for (let i = 0; i < 17; i++) {

                        if (this.winRecordsData.length >= 17) {

                            break;

                        } else {

                            this.winRecordsData.push(this.winRecordsData[i % t]);

                        }

                    }

                }

            } else {

                this.$message.error(data.message);

            }

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
        async listRecordFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listRecord({ id: this.$route.params.id, code: this.$route.query.code });

            loading.close();

            if (data.code == 200) {

                this.recordsData = data.data;

                this.recordsDialog = true;

            } else {

                this.$message.error(data.message);

            }

        },
        async listRecordFuc2() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listRecord2({ id: this.$route.params.id, code: this.$route.query.code });

            loading.close();

            if (data.code == 200) {

                this.recordsData2 = data.data;

                this.recordsDialog2 = true;

            } else {

                this.$message.error(data.message);

            }

        },
        async startLotteryFuc() {

            let _this = this;

            if (this.$route.params.id == null) {

                this.$message.error("活动标识为空，错误访问！");

                window.open("https://katihuo.com/", '_self');

                return;

            }

            if (this.$route.query.code == null) {

                window.open("https://factory.katihuo.com/wx/" + this.$route.params.id, '_self');

                return;

            }

            let data = await startLottery({ id: this.$route.params.id, code: this.$route.query.code, nick: decodeURIComponent(_this.handleStr(this.$route.query.nick)) });

            if (data.code == 200) {

                this.lotteryCount--;

                let idx = -1;

                for (let i = 0; i < _this.prizes.length; i++) {

                    if (_this.prizes[i].id == data.data.id) {

                        idx = i;

                        break;

                    }

                }

                setTimeout(() => {

                    _this.$refs.myLucky.stop(idx);

                }, 2000);

                this.nowJp = data.data1;

                this.nowJp2 = data.data;

                this.zjId = data.data.id;

                this.zjImg = 'https://cdn.bosscaigou.com/' + data.data.img;

                setTimeout(() => {

                    this.zjDialog = true;

                }, 5000);

            } else {

                this.$message.error(data.message);

            }

        },
        async listLotterysFuc() {

            let _this = this;

            if (this.$route.params.id == null) {

                this.$message.error("活动标识为空，错误访问！");

                window.open("https://katihuo.com/", '_self');

                return;

            }

            if (this.$route.query.code == null) {

                window.open("https://factory.katihuo.com/wx/" + this.$route.params.id, '_self');

                return;

            }

            const jsStr = readData("lottery-js-" + this.$route.params.id);

            // var img = document.createElement("img");

            // img.className = 'codics-shop-lottery-hbb';

            // img.src = "https://cdn.bosscaigou.com/threejs/imgs/yasuo_%E9%82%A6%E9%82%A6.webp";

            // document.body.appendChild(img);

            if (jsStr != null) {

                eval(jsStr);

            }

            const cssStr = readData("lottery-css-" + this.$route.params.id);

            if (cssStr != null) {

                loadCss(cssStr);

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listLotterys({ id: this.$route.params.id, code: this.$route.query.code });

            loading.close();

            if (data.code == 200) {

                this.activeData = data.data;

                const { js, css } = data.data;

                if (js) {

                    saveData("lottery-js-" + this.$route.params.id, js);

                    eval(js);

                }

                if (css) {

                    saveData("lottery-css-" + this.$route.params.id, css);

                    loadCss(css);

                }

                document.title = data.data?.name || '邦邦抽奖-大转盘抽奖';

                this.lotteryCount = data?.data2?.count | 0;

                _this.lotteryInfo = data.data;

                _this.prizes = [];

                data.data1.forEach(item => {

                    _this.prizes.push({ id: item.id, background: _this.prizes.length % 2 == 0 ? _this.prizesData.color : _this.prizesData.color2, imgs: [{ src: 'https://cdn.bosscaigou.com' + item.img, height: '30px', width: '30px', top: '7px', ..._this.prizesData.imgs }], fonts: [{ text: item.name, fontColor: _this.prizes.length % 2 == 0 ? _this.prizesData.color3 : _this.prizesData.color4, fontSize: '10px', top: '40px', ..._this.prizesData.fonts }] });

                });

                var _that = this;

                setInterval(() => {

                    enddate = new Date(data.data.stime).getTime();
                    //获取日期对象
                    var oDate = new Date();
                    //现在的毫秒数
                    var nowTime = oDate.getTime();

                    var enddate = new Date(enddate);
                    // 截止时间的毫秒数
                    var targetTime = enddate.getTime();
                    //截止时间距离现在的秒数
                    var second = Math.floor((targetTime - nowTime) / 1000);
                    //整数部分代表的是天；一天有24*60*60=86400秒 ；
                    var day = Math.floor(second / 24 * 60 * 60);
                    //余数代表剩下的秒数；
                    second = second % 86400;
                    //整数部分代表小时；
                    var hour = Math.floor(second / 3600);
                    //余数代表 剩下的秒数；
                    second %= 3600;

                    var minute = Math.floor(second / 60);

                    second %= 60;

                    _that.hourTxt = hour;

                    _that.minuteTxt = minute;

                    _that.secondTxt = second;


                }, 500);

            } else {

                this.$message.error(data.message);

            }

        },
        // 点击抽奖按钮会触发star回调
        startCallback() {

            if (this.prizes.length <= 0) {

                this.$message.error("奖品列表为空！");

                return;

            }

            if (this.lotteryCount <= 0) {

                this.$message.error("您的抽奖次数已用完！");

                return;

            }
            // 调用抽奖组件的play方法开始游戏
            this.$refs.myLucky.play();
            // // 模拟调用接口异步抽奖
            // setTimeout(() => {
            //     // 假设后端返回的中奖索引是0
            //     const index = 0
            //     // 调用stop停止旋转并传递中奖索引
            //     this.$refs.myLucky.stop(index)
            // }, 3000)
            this.startLotteryFuc();

        },
        // 抽奖结束会触发end回调
        endCallback(prize) {
            console.log(prize)
        },
    },
    components: {
        MyDialog
    }
}
</script>

<style>
.codics-lottery-dzp-aaa-body {
    height: fit-content;
    width: 100%;
    min-height: 100vh;
    position: relative;
    float: left;
    box-sizing: border-box;
    overflow: hidden;
}

.codics-lottery-dzp-aaa-img {
    height: fit-content;
    width: 100%;
    position: absolute !important;
    left: 0;
    top: 0;
}

.codics-lottery-dzp-aaa-title {
    height: 24vw;
    width: 100%;
    position: relative !important;
    float: left;
    margin-top: 40px;
    overflow: hidden;
    box-sizing: border-box;
    transform: scale(.85);
}

.codics-lottery-dzp-aaa-tip {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    margin-top: 25px;
    box-sizing: border-box;
}

.codics-lottery-dzp-aaa-tip-txt {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    line-height: 30px;
    text-align: center;
    padding: 0 15px;
    font-size: 13px;
    color: #FFF;
    background: rgba(255, 255, 255, .25);
    backdrop-filter: blur(5px);
    border-radius: 15px;
    border: 1px solid rgba(255, 255, 255, .18);
}

.codics-lottery-dzp-aaa-luckywheel {
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 50px;
    z-index: 5;
}





.codics-lottery-dzp-aaa-records-list-item {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 15px;
    line-height: 40px;
}

.codics-lottery-dzp-aaa-records-list-item-txt {
    height: 40px;
    width: fit-content;
    position: relative;
    float: left;
    font-size: 13px;
    color: #FFF;
    text-align: center;
}

.codics-lottery-dzp-aaa-records-list-item-time {
    height: 40px;
    width: fit-content;
    position: absolute;
    top: 0;
    right: 15px;
    font-size: 13px;
    color: #FFF;
    text-align: center;
}




.codics-shop-lottery-button-box {
    height: 80px;
    width: 100%;
    position: relative;
    float: left;
    perspective: 230px;
    top: -30px;
}

.codics-shop-lottery-button-card {
    height: 100%;
    width: 67%;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    background: linear-gradient(to bottom, #A611E4, #5E06DF);
    transform-origin: top;
    transition: all 1s;
    transform-style: preserve-3d;
    -webkit-transform-origin-z: -16px;
    transform: rotateX(30deg);
    border-radius: 20px 20px 0 0;
    box-sizing: border-box;
    padding: 15px;
}

.codics-shop-lottery-users-card2 {
    height: fit-content !important;
    box-sizing: border-box;
    padding: 15px !important;
    font-size: 14px;
    color: #FFF;
    line-height: 40px;
}

.codics-shop-lottery-button-viw {
    height: calc(100% - 10px);
    width: calc(100% - 10px);
    position: absolute;
    left: 5px;
    top: 5px;
    background: linear-gradient(to bottom, #A611E4, #5E06DF);
    border-radius: 20px 20px 0 0;
    box-shadow: inset 2px 2px 5px #5802C1, inset -3px -3px 6px rgba(174, 93, 236, .3);
    box-sizing: border-box;
}

.codics-shop-lottery-button {
    height: 100%;
    width: calc(50% - 5px);
    position: relative;
    float: left;
    background: #FFBC42;
    border-radius: 9px;
    box-shadow: -1px -1px 2px #FFD84C, 1.5px 1.5px 3px #D9A038;
    line-height: 50px;
    text-align: center;
    font-size: 15px;
    font-weight: bolder;
    transition: .5s;
    user-select: none;
    color: #704f00;
}

.codics-shop-lottery-button:active {
    font-size: 14.9px;
    box-shadow: inset 1px 1px 2px #FFD84C, inset -1.5px -1.5px 3px #D9A038;
}

.codics-shop-lottery-button-card::after {
    content: '';
    height: 30px;
    width: 100%;
    position: absolute;
    top: 100%;
    left: 0;
    background: #390098;
    transform: rotateX(-30deg);
    transform-origin: top;

}

.codics-shop-lottery-wdjp {
    text-decoration: underline;
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    font-size: 10px;
    text-align: center;
    color: #FFF;
    line-height: 30px;
    top: 15px;
    z-index: 10;
}

.codics-shop-lottery-users-title {
    height: 50px;
    width: fit-content;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    line-height: 50px;
    font-size: 17px;
    font-weight: 900;
    margin-top: 30px;
    color: #FFF;

}

.codics-shop-lottery-users-title::before {
    content: '';
    height: 50px;
    width: 160px;
    background: url('https://cdn.bosscaigou.com/huayuan/img/yasuo_%E5%9C%86%E8%A7%92%E7%9F%A9%E5%BD%A2%205%20%E6%8B%B7%E8%B4%9D%202.webp') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: -110px;
    transform: scale(.2);
}

.codics-shop-lottery-users-title::after {
    content: '';
    height: 50px;
    width: 160px;
    background: url('https://cdn.bosscaigou.com/huayuan/img/yasuo_%E5%9C%86%E8%A7%92%E7%9F%A9%E5%BD%A2%205%20%E6%8B%B7%E8%B4%9D.webp') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    right: -110px;
    transform: scale(.2);
}

.codics-shop-lottery-users-box {
    height: 390px;
    /* min-height: 50px; */
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 15px 20px 15px 20px;
}

.codics-shop-lottery-users-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #6431B6;
    border-radius: 10px;
    box-shadow: inset 2px 2px 5px #5802C1, inset -3px -3px 6px rgba(174, 93, 236, .3);
    overflow: hidden;
    padding: 5px 0 5px 0;
    box-sizing: border-box;
}

.codics-shop-lottery-users-card ul {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    list-style-type: none;
    padding-inline-start: 0 !important;
    margin-block-start: 0 !important;
    margin-block-end: 0 !important;
    transform: translate3d(0, 0, 0);
    will-change: transform;
    animation: huaD 5s linear infinite;
}

.codics-shop-lottery-users-card li {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 50px;
    font-size: 14px;
    color: #FFF;
    font-weight: 500;
    list-style-type: none;
    box-sizing: border-box;
    padding: 0 15px 0 15px;
}

.codics-shop-lottery-users-card div {
    height: 50px;
    width: fit-content;
    position: absolute;
    right: 15px;
    top: 0;
    line-height: 50px;
}

@keyframes huaD {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(-350px);
    }
}

.codics-shop-detail-wyth {
    height: 50px;
    width: 100%;
    position: fixed;
    bottom: 0;
    background: #F53033;
    line-height: 50px;
    font-size: 14px;
    color: #FFF;
    text-align: center;
}

.codics-lottery-dzp-aaa-zj-btn {
    height: 40px;
    width: calc(100% - 30px);
    position: absolute;
    margin: auto;
    bottom: 15px;
    left: 0;
    right: 0;
    border-radius: 3px;
    border: 1px solid rgba(255, 255, 255, .3);
    text-align: center;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 13px;
    color: #FFF;
}


.codics-shop-lottery-jphx-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 15px;
    overflow: hidden;
}

.codics-shop-lottery-jphx-card {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: #FFF;
    border-radius: 5px;
    border-color: rgba(0, 0, 0, 0) !important;
}

.codics-shop-lottery-jphx-card::after {
    content: '';
    height: 1px;
    width: calc(100% - 40px);
    position: absolute;
    margin: auto;
    top: 100px;
    left: 0;
    right: 0;
    border-bottom: 2px dashed #D6DAD4;
}

.codics-shop-lottery-jpxx-view {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-shop-lottery-jpxx-img {
    height: 100%;
    width: 100px;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 25px;
}

.codics-shop-lottery-jpxx-qrcode {
    height: calc(100vw - 100px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-shop-lottery-jpxx-qrcode-img {
    height: 150px;
    width: 150px;
    position: absolute !important;
    margin: auto;
    top: -20px;
    left: 0;
    right: 0;
    bottom: 0;
}

.codics-shop-lottery-jphx-dialog .el-drawer {
    background-color: #6431B6 !important;
}

.codics-shop-lottery-jphx-dialog .el-drawer__header {
    color: #FFF !important;
}

.codics-shop-lottery-jphx-card-radio {
    height: 40px;
    width: 40px;
    position: absolute;
    background: #6431B6;
    border-radius: 20px;
    top: 80px;
}

.codics-shop-lottery-jphx-card-tip {
    height: 35px;
    width: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 35px;
    text-align: center;
    font-size: 13px;
    color: #867a96;
    background: #f1d9f8;
    border-radius: 0 0 5px 5px;
}

.codics-shop-lottery-jpxx-name {
    height: 36px;
    width: calc(100% - 100px);
    position: relative;
    float: left;
    line-height: 66px;
    font-size: 14px;
}

.codics-shop-lottery-jpxx-count {
    height: 100px;
    width: 80px;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    text-align: center;
    line-height: 100px;
    font-size: 25px;
    color: #6431B6;
    font-weight: bolder;
}
</style>


<style>
/* .codics-shop-lottery-button-box {
    height: 17.5vw !important;
    width: 100% !important;
    background-image: url(https://cdn.bosscaigou.com/threejs/imgs/yasuo_%E5%BA%95%E5%BA%A7.webp);
    background-size: 49.7% 100%;
    left: 50% !important;
    transform: translateX(-50%);
    background-position-x: 50%;
    background-repeat: no-repeat;
    margin-top: 2px !important;
}

.codics-lottery-dzp-aaa-luckywheel {
    margin-top: 40px !important;
}

.codics-shop-lottery-hbb{
    height: 34vw;
    width: 25vw;
    position: absolute;
    object-fit: fill;
    right: 5px;
    top: 497px;
}

.codics-lottery-dzp-aaa-title{
    margin-top: 58px !important;
}

.codics-lottery-dzp-aaa-tip{
    margin-top: 40px !important;
}

.codics-shop-lottery-button-card{
    top: 81px !important;
    background: unset !important;
}

.codics-shop-lottery-button-card::after{
    content: unset !important;
}

.codics-shop-lottery-button-viw{
    display: none !important;
}

.codics-shop-lottery-button{
    height: 30px !important;
    line-height: 30px !important;
    border-radius: 3px !important;
    font-size: 12px !important;
} */



/* 
.codics-lottery-dzp-cjjg{
    background: rgba(0,0,0,.2) !important;
}
.codics-lottery-dzp-cjjg .codics-sjnr-wdialog-dialog {
    background: unset !important;
    backdrop-filter: unset !important;
    border: unset !important;
}

.codics-lottery-dzp-cjjg .codics-sjnr-wdialog-dialog {
    height: 360px !important;
    background-image: url(https://cdn.bosscaigou.com/huayuan/img/yasuo_%E5%BC%B9%E7%AA%97.webp) !important;
    background-size: 100% 100% !important;
    background-position-x: -21px !important;
}

.codics-lottery-dzp-cjjg .codics-sjnr-wdialog-dialog-top {
    display: none !important;
}

.codics-lottery-dzp-cjjg .codics-lottery-dzp-aaa-zj-btn {
    width: calc(100% - 170px) !important;
    bottom: 70px !important;
    background: linear-gradient(to bottom right, #FFEDD1, #FFF) !important;
    border: 1px solid linear-gradient(to bottom right, #FACFB8, #F9E1FF) !important;
    color: #FF2B78 !important;
    border-radius: 5px !important;
}

.codics-lottery-dzp-cjjg .codics-sjnr-wdialog-dialog-content{
    height: 100% !important;
    overflow: hidden !important;
    max-height: unset !important;
}

.codics-lottery-dzp-cjjg .el-image{
    height: 70px !important;
    width: 70px !important;
    top: 18px !important;
} */
</style>